import { useEffect } from 'react';
import { type BaseItem } from '@algolia/autocomplete-core';

export interface Facet extends BaseItem {
	label: string;
	value: string;
}

export function AutocompleteDropdown({
	activeIndex,
	handleCloseDropdown,
	onSelect,
	results,
}: {
	activeIndex: number;
	handleCloseDropdown: () => void;
	onSelect: (item: string) => void;
	results: string[];
}) {
	const handleClick = (item: string) => {
		onSelect(item);
		handleCloseDropdown();
	};

	useEffect(() => {
		const activeElement = document.querySelector(
			`li[data-index="${activeIndex}"]`,
		);
		if (activeElement) {
			activeElement.scrollIntoView({ block: 'nearest' });
		}
	}, [activeIndex]);

	return (
		<ul className="absolute z-10 w-full bg-white border border-neutral-200 rounded-md mt-1 max-h-60 overflow-y-auto dark:border-neutral-800">
			{results.map((item, index) => (
				<li
					className={`px-4 py-2 cursor-pointer text-[#00182E] ${
						index === activeIndex ? 'bg-gray-200' : 'hover:bg-gray-200'
					}`}
					data-index={index}
					key={item}
					onClick={() => handleClick(item)}
				>
					{item}
				</li>
			))}
		</ul>
	);
}
